import { Box, Stack, Skeleton } from "@mui/material";

const BudgetControlSkel = () => {
  return (
    <Box sx={{ mt: 2 }}>
      {/* Tabs Skeleton */}
      <Stack direction="row" spacing={1} mb={2} justifyContent="center">
        <Skeleton variant="rounded" width="49%" height={32} />
        <Skeleton variant="rounded" width="49%" height={32} />
      </Stack>

      {/* Chart card skeleton */}
      <Box
        sx={{
          borderRadius: 2,
          border: "1px solid #e0e0e0",
          p: 2,
          mb: 2,
        }}
      >
        <Skeleton variant="rounded" width="100%" height={200} />
      </Box>

      {/* List item skeletons */}
      {[1, 2, 3].map((item) => (
        <Box
          key={item}
          sx={{
            borderRadius: 2,
            border: "1px solid #e0e0e0",
            p: 2,
            mb: 2,
          }}
        >
          <Stack spacing={1.2}>
            <Skeleton width={120} height={20} />
            <Stack direction="row" justifyContent="space-between">
              <Skeleton width={160} height={18} />
              <Skeleton width={70} height={18} />
            </Stack>
            <Stack direction="row" justifyContent="space-between">
              <Skeleton width={140} height={18} />
              <Skeleton width={80} height={18} />
            </Stack>
          </Stack>
        </Box>
      ))}
    </Box>
  );
};

export default BudgetControlSkel;
